export default {
  install(Vue, store) {
    Vue.prototype.$loader = {

      get options() {
        return store.getters.getLoadingOptions;
      },

      get isLoading() {
        return this.options.loading;
      },

      /**
       * Allowed options:
       *
       * @option target {boolean} - start loading in target
       */
      start(options = {}) {
        return store.dispatch('SET_APP_LOADING', {
          loading: true,
          ...options,
        });
      },

      stop() {
        return store.dispatch('SET_APP_LOADING', false);
      },
    };
  },
};
